<!-- Search, filters and sort -->
<div class="gl-toolbar">
  <app-search-input
    class="gl-search"
    placeholder="Search organizations"
    [debounce]="350"
    (valueChange)="updateSearchTerm($event)"
  />

  <div class="gl-filter" (clickOutside)="closeFilters()">
    <button
      #filterTrigger
      type="button"
      class="gl-filter__trigger"
      [class.is-active]="filtersActive"
      aria-haspopup="dialog"
      [attr.aria-expanded]="showFilters"
      [attr.aria-controls]="showFilters ? 'org-filter-panel' : null"
      (click)="toggleFilters()"
    >
      <span class="bk-sym" aria-hidden="true">tune</span>
      Filters
      @if (activeFilterCount) {
        <span class="gl-filter__count" [attr.aria-label]="activeFilterCount + ' active'">{{ activeFilterCount }}</span>
      }
    </button>

    @if (showFilters) {
      <div #filterPanel id="org-filter-panel" class="gl-filter__panel" role="dialog" aria-label="Filter organizations">
        <div class="bk-field">
          <label class="bk-field__label" for="org-f-industry">Industry</label>
          <select
            id="org-f-industry"
            class="bk-field__input"
            (change)="setIndustryFilter($any($event.target).value)"
          >
            <option value="" [selected]="!industryFilter">Any industry</option>
            @for (industry of industries; track industry.value) {
              <option [value]="industry.value" [selected]="industry.value === industryFilter">{{ industry.label }}</option>
            }
          </select>
        </div>

        <div class="bk-field">
          <label class="bk-field__label" for="org-f-country">Country</label>
          <select
            id="org-f-country"
            class="bk-field__input"
            (change)="setCountryFilter($any($event.target).value)"
          >
            <option value="" [selected]="!countryFilter">Any country</option>
            @for (country of countries; track country) {
              <option [value]="country" [selected]="country === countryFilter">{{ country }}</option>
            }
          </select>
        </div>

        <div class="gl-filter__foot">
          <button type="button" class="bk-more" [disabled]="!filtersActive" (click)="clearAllFilters()">
            Clear filters
          </button>
          <button type="button" class="bk-btn bk-btn--ghost gl-filter__done" (click)="closeFilters()">Done</button>
        </div>
      </div>
    }
  </div>

  <app-sort-dropdown
    [groups]="sortGroups"
    [selectedValue]="sortCriteria"
    (selectionChange)="updateSortCriteria($any($event))"
  />

  <span class="gl-toolbar__spacer"></span>

  <p class="gl-count" aria-live="polite">{{ countLine }}</p>
</div>

<!-- Active filters -->
@if (filtersActive) {
  <div class="gl-chips" role="group" aria-label="Active filters">
    @if (industryFilter) {
      <span class="bk-chip gl-chip">
        Industry: {{ industryLabel }}
        <button type="button" class="gl-chip__x" aria-label="Remove the industry filter" (click)="clearFilter('industry')">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </span>
    }
    @if (countryFilter) {
      <span class="bk-chip gl-chip">
        Country: {{ countryFilter }}
        <button type="button" class="gl-chip__x" aria-label="Remove the country filter" (click)="clearFilter('country')">
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </span>
    }
    <button type="button" class="bk-more" (click)="clearAllFilters()">Clear all</button>
  </div>
}

<!-- Selection bar: what to do with the ticked organizations -->
@if (selectedOrganizations.length) {
  <div class="gl-select" role="region" aria-label="Selected organizations">
    <span class="gl-select__count">{{ selectionLabel }}</span>
    <span class="gl-select__actions">
      <button
        *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
        type="button"
        class="gl-select__btn"
        (click)="handleAction('send-sms')"
      >
        <span class="bk-sym" aria-hidden="true">send</span>
        Message
      </button>
      <button
        *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
        type="button"
        class="gl-select__btn"
        (click)="handleAction('delete')"
      >
        <span class="bk-sym" aria-hidden="true">delete</span>
        Delete
      </button>
    </span>
    <button type="button" class="gl-select__clear" (click)="resetSelectedOrganizations()">Clear selection</button>
  </div>
}

<organizations-table
  class="gl-table"
  [params]="reactiveParams"
  [searchTerm]="searchTerm"
  [filtered]="filtersActive"
  (getSelections)="updateSelectedOrganizations($event)"
  (totalChange)="updateTotal($event)"
  (clearFilters)="clearSearchAndFilters()"
/>

<!-- MODALS -->
<app-prompt-card
  [title]="deleteTitle"
  [buttonText]="deleteButton"
  tone="danger"
  impact="This cannot be undone."
  impactIcon="warning"
  [openModal]="showDeleteOrganizationsPrompt"
  (onClose)="closeDeleteOrganizationsPrompt()"
  (onButtonClick)="deleteSelectedOrganizations()"
  [loading]="deleting"
>
  <p class="gl-prompt">{{ deleteImpact }}</p>
</app-prompt-card>
